import './index.css'

const BookShelfItems = props => {
  const {shelf, activeShelf, onChangeActiveShelf} = props
  const {value, label} = shelf
  const activeClassName = activeShelf === value ? 'active-class' : ''

  const onClickLabel = () => {
    onChangeActiveShelf(value)
  }

  return (
    <p onClick={onClickLabel} className={`${activeClassName} shelf`}>
      {label}
    </p>
  )
}

export default BookShelfItems
